module.exports = __webpack_public_path__ + "static/media/db_arrow_right.a45b84de.svg";